<div class="content-wrapper">
  <button
    class="button-undecorated close-button"
    style="border-radius: 100%"
    [attr.aria-label]="'Close image preview modal'"
    (click)="closeModal()"
  >
    <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
  </button>
  <img
    [src]="imageSrc()"
    [alt]="'Image preview'"
    class="preview-img"
  />
</div>
